//console.log('>> Home page');
import '@glidejs/glide/dist/glide.min.js';
import * as AOS from 'aos/dist/aos.js';
//import Masonry from 'masonry-layout';
//import imagesLoaded from 'imagesloaded';

//import './modals';
//import './collapsible';
//import Glide, { Controls } from '@glidejs/glide/dist/glide.modular.esm'

AOS.init();


const menuToggle = document.getElementById('menu-toggle');
const navbar = document.getElementById('navbar__nav');

menuToggle.addEventListener('click', () => {

    navbar.classList.toggle('open');

});

const navLinks = document.querySelectorAll('.nav-link');
navLinks.forEach(link => {
    link.addEventListener('click', () => {
        if (window.innerWidth < 768) {
            navbar.classList.remove('open');
        }
    });
});


// ScrollTo
document
    .querySelectorAll('a[href^="#"]')
    .forEach(trigger => {
        trigger.onclick = function (e) {
            e.preventDefault();
            let hash = this.getAttribute('href');
            let target = document.querySelector(hash);
            let headerOffset = window.innerWidth < 768 ? 80 : 175;
            let elementPosition = target.offsetTop;
            let offsetPosition = elementPosition - headerOffset;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        };
    });



// facebook wall
const news = document.getElementById('news');

if (news) {
    document.addEventListener("DOMContentLoaded", function () {
        // Ziel-HTML-Element
        const feedContainer = document.getElementById('feed-container');
        // API-Anfrage, um den Feed der Seite abzurufen
        fetch(`api/facebook_feed.php`)
            .then(response => response.json())
            .then(data => {
                const preloader = document.getElementById('preloader');
                if (preloader) preloader.style.display = 'none';
                // Verarbeite die Antwortdaten
                if (data.error) {
                    feedContainer.innerHTML = `Fehler beim Abrufen des Feeds: ${data.error.message}`;
                } else {
                    const feed = data.data;
                    let html = '';
                    for (let i = 0; i < feed.length; i++) {
                        const post = feed[i];
                        // timestamp umwandeln
                        const timestamp = post.created_time;
                        const date = new Date(timestamp);
                        const formattedTimestamp = `${date.getDate().toString().padStart(2, "0")}.${(date.getMonth() + 1).toString().padStart(2, "0")}.${date.getFullYear()}`;
                        /*var searchString = "Profilbild";
                        if (post.message.includes(searchString)) {
                            console.log("Die Zeichenfolge wurde gefunden.");
                        } else {
                            console.log("Die Zeichenfolge wurde nicht gefunden.");
                        }
                        */
                        html += `
                        <div class="card">
                        <p class="timestamp text-end mb-0">${formattedTimestamp}</p>
                        `;

                        // falls message leer ist, zb. nur ein Bild gepostet wurde
                        if (!post.message) {
                            post.message = ''
                        }
                        // Überprüfe, ob das Post-Objekt ein Bild enthält
                        if (post.hasOwnProperty('full_picture')) {
                            html += `
                              <a href="${post.permalink_url}" class="main-link" target="_blank">
                                  <img src="${post.full_picture}" alt="Bild ${i + 1}" class="aspect-square object-cover mb-4 post-image" loading="lazy">
                              </a>`;
                        }
                        html += `
                            <div class="card-body">
                                <div class="card-text">
                                    <p class="message text-base">${post.message}</p>
                        `;
                        if (post.hasOwnProperty('story')) {
                            html += `<p class="text-sm"><em>${post.story}</em></p>`;
                        }
                        // braucht mehr berechtigungen (pages_read_engagement)
                        if (post.hasOwnProperty('attachments')) {
                            //html += `<p>Attachment: ${post.attachments}</p>`;

                            const attachments = post.attachments;
                            html += `<div class="attachment font-light text-base">`;
                            attachments.data.forEach(attachment => {
                                //html += `TITLE: ${attachment.title}<br>TYPE: ${attachment.type}<br>URL: ${attachment.url}`;
                                if (attachment.type === 'share') {
                                    html += `<a href="${attachment.url}" class="attach_is_link " target="_blank">Link ansehen</a>`;
                                }
                                if (attachment.type === 'photo') {
                                    // ist schon im header
                                    //html+=`${attachment.url}`;
                                }
                                if (attachment.type === 'event') {
                                    html += `<a href="${attachment.url}" class="attach_is_event" target="_blank">${attachment.title}</a>`;
                                }
                                if (attachment.type === 'album') {
                                    html += `<a href="${attachment.url}" class="attach_is_album" target="_blank">Album ansehen</a>`;
                                }
                                if (attachment.type === 'video_autoplay') {
                                    html += `
                                    <div class="ratio ratio-16x9">
                                        <iframe class="w-full" src="https://www.facebook.com/plugins/video.php?height=314&href=${attachment.url}&show_text=false&t=0" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>
                                    </div>`;
                                }
                            });

                            html += `</div>`;

                        }

                        if (post.hasOwnProperty('message_tags')) {
                            const messageTags = post.message_tags;
                            html += `<div class="mt-8 tags italic font-light text-base">`;
                            messageTags.forEach(tag => {
                                html += `<span class="tag block"><a href="https://facebook.com/${tag.id}" target="_blank">${tag.name}</a>&nbsp;</span>`;
                            });
                            html += `</div>`;
                        }
                        html += `</div>
                            `

                        //html += `<div class="card-footer url">
                        //<a href="${post.permalink_url}" target="_blank"><img class="icon"></a></div>`;
                        html += `</div></div>`;
                    }
                    feedContainer.innerHTML = html;
                }
                //initMasonry();
            })

            .catch(error => {
                feedContainer.innerHTML = `Fehler beim Abrufen des Feeds: ${error}`;
            });
        /*
        function initMasonry() {
            var grid = document.querySelector('.masonry');
            var msnry;

            imagesLoaded(grid, function () {
                // init Isotope after all images have loaded
                msnry = new Masonry(grid, {
                    itemSelector: '.masonry-item',
                    columnWidth: 0,
                    percentPosition: true
                });
            });
        };
        */
    });
}


/* YouTube 2-Klick-Lösung */
function loadYoutubeVideo(facade, autoplay) {
    const videoId = facade.dataset.videoid;
    const container = facade.closest('.videoembed');
    const iframe = document.createElement('iframe');
    iframe.className = 'absolute top-0 left-0 w-full h-full';
    iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?controls=1&modestbranding=1&rel=0&showinfo=0${autoplay ? '&autoplay=1' : ''}`;
    iframe.title = 'YouTube video player';
    iframe.frameBorder = '0';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    container.replaceChild(iframe, facade);
}

document.querySelectorAll('.yt-facade').forEach(facade => {
    facade.addEventListener('click', (e) => {
        const clickedFacade = facade;
        document.querySelectorAll('.yt-facade').forEach(f => {
            loadYoutubeVideo(f, f === clickedFacade);
        });
    });
});
